import { CustomFieldTypeEnum } from '../enums/customFieldType.enum';

export class CustomField {
    id: string;
    name: string;
    type: CustomFieldTypeEnum;
    property: string;
    data: string;
    isPii?: boolean;
}
